import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import {Row, Button, Space, Form} from "antd";
import "./Search.scss";
import {DataField} from "types/models";
import InputFields from "../InputFields/InputFields";
import Icon from "assets/icons";
import {SearchOutlined} from "@ant-design/icons";
import {Store} from "antd/es/form/interface";
import {normalizePhoneNumber} from "../../../helper/common";

type PropsType = {
  fields: DataField[];
  onClickSearch?: () => void;
  onReset?: () => void;
  initialValues?: Store;
  defaultFieldsValue?: {
    label: string;
    value: any;
  }[];
  // Thêm prop cho việc ẩn/hiện nút "Tìm kiếm nâng cao"
  showAdvancedSearch?: boolean;
};

const Search = forwardRef((props: PropsType, ref) => {
  const [expand, setExpand] = useState(false);
  const {fields, onClickSearch, onReset, initialValues, defaultFieldsValue} =
      props;

  const defaultFields = fields.filter(field => !field.expand);
  const expandFields = fields.filter(field => field.expand);

  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getData: () => {
      const allParams = form.getFieldsValue();

      return allParams;
    },
    setFieldValue: (name, value) => {
      form.setFieldValue(name, value);
    },
  }));

  const handleOnReload = () => {
    form.resetFields();

    // if (onReset) {
    onReset();

    // form.setFieldsValue({
    //   ngayTaoTu: initialValues?.ngayTaoTu,
    //   ngayTaoDen: initialValues?.ngayTaoTDen,
    // });
    // }
  };

  useEffect(() => {

    form.setFieldsValue({

    });
  }, [initialValues]);

  useEffect(() => {
    if (defaultFieldsValue) {
      defaultFieldsValue.forEach(field => {
        form.setFieldsValue({
          [field.label]: field.value,
        });
      });
    }
  }, [JSON.stringify(defaultFieldsValue)]);

  return (
      <div className="expand-search-container" style={{width: "100%"}}>
        <Space direction="vertical" style={{width: "100%"}}>
          <Form form={form} labelAlign="left">
            <Row gutter={[16, 8]}>
              <InputFields data={defaultFields} />
              {expand ? <InputFields data={expandFields} /> : undefined}
            </Row>
          </Form>
          <Row justify={"end"}>
            <Space>
              <Button
                  onClick={() => setExpand(!expand)}
                  className="custom-btn"
                  style={{ display: props.showAdvancedSearch ? "block" : "none" }}
              >
                Tìm kiếm nâng cao
                {!expand ? <Icon.down rev={0} /> : <Icon.up rev={0} />}
              </Button>
              <Button
                  htmlType="submit"
                  onClick={onClickSearch}
                  type="primary"
                  icon={<SearchOutlined rev={0} />}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Row>
        </Space>
      </div>
  );
});
// })

// ({fields, onClickSearch}: PropsType) => {
export default Search;
